import React from 'react'
import Header from '../components/header'
import Footer from '../components/footer'

export default function Privacy() {
  return (
    <div>
      <Header/>

      <div id="privacy-policy">
  <h1>Privacy Policy</h1>
  <p>Effective Date: April 3, 2025</p>

  <p>
    At <strong>ToolISO</strong>, your privacy is very important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our website and services.
  </p>

  <h2>1. Information We Collect</h2>
  <p>
    We do not collect any personally identifiable information unless you voluntarily provide it to us. Most of our tools work entirely within your browser and do not transmit any data to our servers.
  </p>

  <ul>
    <li>
      <strong>Usage Data:</strong> We may collect non-personal data such as device type, browser type, language, and how you interact with our site (e.g. pages visited).
    </li>
    <li>
      <strong>Cookies:</strong> ToolISO uses cookies to improve your experience. You can choose to disable cookies in your browser settings.
    </li>
  </ul>

  <h2>2. How We Use Your Information</h2>
  <p>We use the limited information we collect to:</p>
  <ul>
    <li>Improve our tools and services</li>
    <li>Analyze usage trends and website performance</li>
    <li>Fix bugs and improve security</li>
  </ul>

  <h2>3. Third-Party Services</h2>
  <p>
    We may use third-party analytics tools like Google Analytics to understand how visitors use our site. These tools may use cookies or similar technologies to collect data about your behavior anonymously.
  </p>

  <h2>4. Data Security</h2>
  <p>
    We take reasonable steps to protect your data and ensure that our site is secure. However, please be aware that no system is completely foolproof, and we cannot guarantee absolute security.
  </p>

  <h2>5. Data Retention</h2>
  <p>
    Since most of our tools work entirely on the client side, we do not store your files or personal data. If any temporary data is collected, it is deleted automatically after processing.
  </p>

  <h2>6. Your Rights</h2>
  <p>You have the right to:</p>
  <ul>
    <li>Access any personal data we may have (though usually we don’t store any)</li>
    <li>Request deletion of your data</li>
    <li>Opt out of cookies through your browser settings</li>
  </ul>

  <h2>7. Changes to This Policy</h2>
  <p>
    We may update this Privacy Policy from time to time. Changes will be posted on this page with the updated effective date.
  </p>

  <h2>8. Contact Us</h2>
  <p>
    If you have any questions or concerns about our Privacy Policy, please contact us at:
    <br />
    <a href="mailto:support@tooliso.com">support@tooliso.com</a>
  </p>

  <p>Thank you for trusting <strong>ToolISO</strong>.</p>
</div>


      <Footer/>
    </div>
  )
}
